// 404.vue

<template>
  <div id="div404">
    <br /><br />
    <h1>Error 404</h1>
    <br />
    <p>La página solicitada no existe.</p>
    <br />
    <a href="#" @click.prevent="back">Volver atrás</a>
    <br id="brfinal" />
  </div>
</template>

<script>
//Página a mostrar cuando la página solicitada no se encuentra
// @group Interfaz extra
export default {
  name: "404",
  methods: {
    // Volver a la página anterior
    back() {
      this.$router.go(-1);
    }
  }
};
</script>

<style>
#div404 {
  margin-top: 15%;
  margin-bottom: 15%;
  text-align: center;
}
</style>
